export default {"src":"/_next/static/media/exclusive-upgrade-label.cca03703.svg","height":61,"width":230,"blurWidth":0,"blurHeight":0};